Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatIBAN = void 0;

var formatIBAN = function formatIBAN(iban) {
  return iban.replace(/(.{4})/g, '$1 ');
};

exports.formatIBAN = formatIBAN;
//# sourceMappingURL=IBANUtils.js.map